import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import apiClient from '../../api/axiosConfig';
import { useToast } from '../../contexts/ToastContext';
import MetaTagsUpdater from '../../components/MetaTagsUpdater';

function Unsubscribe() {
  const { token } = useParams();
  const { addToast } = useToast();
  const [message, setMessage] = useState('Processing your unsubscription request...');
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleUnsubscribe = async () => {
      if (!token) {
        setMessage('Invalid unsubscribe link. Token is missing.');
        setIsSuccess(false);
        setLoading(false);
        addToast('Invalid unsubscribe link.', 'error');
        return;
      }

      try {
        const response = await apiClient.get(`/unsubscribe-newsletter/${token}`);
        if (response.data.success) {
          setMessage(response.data.message || 'You have been successfully unsubscribed from our newsletter.');
          setIsSuccess(true);
          addToast(response.data.message || 'Unsubscribed successfully!', 'success');
        } else {
          setMessage(response.data.message || 'Failed to unsubscribe. Please try again.');
          setIsSuccess(false);
          addToast(response.data.message || 'Unsubscription failed.', 'error');
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'An error occurred during unsubscription.';
        setMessage(errorMessage);
        setIsSuccess(false);
        addToast(errorMessage, 'error');
      } finally {
        setLoading(false);
      }
    };

    handleUnsubscribe();
  }, [token, addToast]);

  return (
    <div className="min-h-screen bg-bg-dark text-text-gray flex items-center justify-center py-20">
      <MetaTagsUpdater pageKey="Unsubscribe" />
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg border border-border-subtle text-center max-w-md w-full">
        {loading ? (
          <div className="flex items-center justify-center">
            <svg className="animate-spin h-8 w-8 text-accent-red" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p className="ml-3 text-lg text-text-white">Loading...</p>
          </div>
        ) : (
          <>
            <h1 className={`text-3xl font-bold mb-4 ${isSuccess ? 'text-green-500' : 'text-accent-red'}`}>
              {isSuccess ? 'Unsubscribed!' : 'Unsubscription Failed'}
            </h1>
            <p className="text-lg text-text-white mb-6">{message}</p>
            <Link to="/" className="bg-accent-red text-text-white rounded-md px-6 py-3 font-bold transition-all duration-300 hover:bg-red-700">
              Go to Homepage
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default Unsubscribe;